<div class="available-dates-operation">
    <span class="time-details">
        <input type="date" value="{{ defaultValues.date }}" (change)="onValueChange($event, 'date')" />
    </span>
    <span class="time-details">
        <input
            type="time"
            value="{{ defaultValues.openingTime }}"
            (change)="onValueChange($event, 'openingTime')"
        />
    </span>

    <span class="time-details">
        <input
            type="time"
            value="{{ defaultValues.closingTime }}"
            (change)="onValueChange($event, 'closingTime')"
        />
    </span>
</div>
